import { runInAction } from "mobx";

export interface OptimisticUpdateConfig<T> {
  updateFn: () => void;
  apiCall: () => Promise<T>;
  rollbackFn: () => void;
  onSuccess?: (result: T) => void;
  onError?: (error: Error) => void;
}

/**
 * Базовый класс для optimistic updates
 * Устраняет дублирование кода и обеспечивает консистентность
 */
export class BaseOptimisticMutation {
  async executeWithOptimisticUpdate<T>(
    config: OptimisticUpdateConfig<T>
  ): Promise<T> {
    const { updateFn, apiCall, rollbackFn, onSuccess, onError } = config;

    // Применяем optimistic update
    runInAction(() => {
      updateFn();
    });

    try {
      const result = await apiCall();
      if (onSuccess) {
        runInAction(() => {
          onSuccess(result);
        });
      }
      return result;
    } catch (error) {
      // Откатываем изменения при ошибке
      runInAction(() => {
        rollbackFn();
      });
      const errorObj =
        error instanceof Error ? error : new Error(String(error));
      if (onError) {
        onError(errorObj);
      }
      throw errorObj;
    }
  }
}
